import { useAuth } from '@/hooks/useAuth';
import { hasInProgressDraft, useCreateStartupStore } from '../store/createStartupStore';

/**
 * True when the current user has an in-progress create-startup wizard draft
 * (`createStartupStore`'s `drafts[user.id]`) worth resuming. Feature-owned so
 * `AppLayout` can compose it into `AppNavbar`'s primary CTA without that
 * layout component importing from `features/` directly.
 */
export function useHasInProgressStartupDraft(): boolean {
  const { user } = useAuth();
  const draft = useCreateStartupStore((state) => (user ? state.drafts[user.id] : undefined));
  return hasInProgressDraft(draft);
}
